/** @file English catalog part of area E7 (W3-03); replaced whole by that area. */

/** The `general` block of the Settings screen (spread into `settings`). S0 composes it into `en`. */
export const settingsExtraEn = { general: 'General' } as const;
